import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  FaGoogle,
  FaFacebook,
  FaApple,
  FaEyeSlash,
  FaEye,
} from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import axios, { all } from "axios";
import baseURL from "./baseURL/BaseURL";
import sideImage from "../../assets/images/indian-wedding-bride-and-groom-in-traditional-wed-2023-11-27-05-04-34-utc.jpg";
import { authSliceActions } from "../../redux/slices/authSlice";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const LoginScreen = () => {

  var query = useQuery();
  var action = query.get("action");
  
  useEffect(() => {
    if (action === "profile-click") {
      toast.error("You need to login for viewing profiles");
    }
  }, []);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      Object.values(validationErrors).forEach((error) => {
        toast.error(error);
      });
      setLoading(false);
      return;
    }

    try {
      const response = await baseURL.post(`/users/sign_in`, {
        user: { email, password },
      });
      if (response.status === 200) {
        dispatch(authSliceActions.getRole(response.data.user.role));
        const { token } = response.data;
        localStorage.setItem("authToken", token);
        toast.success("Login Successfully");
        setTimeout(() => {
          navigate("/");
          window.location.reload();
        }, 2000);
      }
    } catch (error) {
      console.log("eroorororor".error)
      console.log("eroorororor".error)
      console.log("eroorororor".error)
      console.log("eroorororor".error)
      setLoading(false);
      let errorMessage =
        error.response?.data?.error || "Something Went Wrong";
        const response = error.response || {};
        if(!!response.data.attempts_data && response.data.attempts_data.remaining >= 0) {
          const remaining_attempts = parseInt(response.data.attempts_data.remaining);
          errorMessage += `. You have ${remaining_attempts} attempts left.`;
        }
      toast.error(errorMessage);
    }
  };

  const validateForm = () => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
      errors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      errors.email = "Please enter a valid email address";
    }

    if (!password) {
      errors.password = "Password is required";
    } else if (password.length < 8) {
      errors.password = "Password must be at least 8 characters long";
    }

    return errors;
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <ToastContainer />
      <p className="bg-gradient-to-br from-[#ffcbdd] via-[#e8e8e8]] to-[#ec547d] text-center p-4">
        <span className="pr-2">New User? {" "}</span>
        <Link to="/signup">
          <span className="w-full bg-[#730000] text-white py-2 px-5 rounded-md font-semibold hover:bg-[#730000] transition font-serif">
            Register
          </span>
        </Link>
      </p>
      <div className="flex h-screen">
        <div className="w-1/2 max-md:w-full flex flex-col justify-center items-center bg-white px-8">
          <div className="w-full max-w-md">
            <h2 className="text-3xl font-bold text-center mb-2 font-serif">
              Welcome back!
            </h2>
            <p className="text-center text-gray-500 mb-6 font-serif">
              Enter your credentials to access your account
            </p>
            {/* <div className="flex justify-center gap-4 mb-6">
              <button className="bg-[#e17777] w-20 flex justify-center rounded-full p-3">
                <FaGoogle className="text-[#730000]" />
              </button>
              <button className="bg-blue-100 w-20 flex justify-center rounded-full p-3">
                <FaFacebook className="text-blue-500" />
              </button>
              <button className="bg-gray-100 w-20 flex justify-center rounded-full p-3">
                <FaApple className="text-black" />
              </button>
            </div> */}
            <form onSubmit={handleLogin} className="space-y-4">
              <div>
                <label className="block text-gray-600 mb-1 font-serif">
                  Email
                </label>
                <input
                  type="email"
                  placeholder="example.email@gmail.com"
                  className="w-full px-4 py-2 border font-serif border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div>
                <label className="block text-gray-600 mb-1 font-serif">
                  Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter at least 8+ characters"
                    className="w-full px-4 py-2 border font-serif border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-700 cursor-pointer font-serif"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? <FaEye /> : <FaEyeSlash />}
                  </span>
                </div>
              </div>

              <div className="flex items-center justify-between text-sm font-serif">
                <label className="flex items-center text-gray-600">
                  <input type="checkbox" className="mr-2 font-serif" />
                  Keep me logged in
                </label>
                <Link
                  to="/forgot-password"
                  className="text-blue-500 hover:underline font-serif"
                >
                  Forgot password?
                </Link>
              </div>

              <button
                type="submit"
                className="w-full bg-[#730000] text-white py-2 rounded-md font-semibold hover:bg-[#730000] transition font-serif"
                disabled={loading}
              >
                {loading ? "Logging in..." : "Login"}
              </button>
            </form>
            <p className="text-center my-3">or</p>
            <button
              type="submit"
              className="w-full bg-[#ED5150] text-white py-2 rounded-md font-semibold  transition"
            >
              <Link to="/otpsender" className="font-serif">
                Login via OTP
              </Link>
            </button>
          </div>
        </div>

        {/* Right Side: Image */}
        <div className="w-1/2 max-md:hidden relative flex items-center justify-center">
          <img src={sideImage} className="pr-10 rounded-lg" />
        </div>
      </div>
    </>
  );
};

export default LoginScreen;
